export const GET_ANIMATION = "GET_ANIMATION";
export const SET_ANIMATION = "SET_ANIMATION";
